// generic-client
/* eslint-disable import/prefer-default-export */
import * as Sentry from '@sentry/react';
import { readNotifications, writeNotifications } from 'lib/apollo/clientSchema/Notification';

export const resetNotifications = () => {
  try {
    const notifications = readNotifications();
    if (notifications) {
      writeNotifications(notifications.filter((i) => i.persist));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};
